(() => {
  const SELECTOR = '[data-lucien-reviews-slider]';
  const DRAG_THRESHOLD = 4;

  const initSlider = (slider) => {
    if (!slider || slider.dataset.lucienReviewsReady === 'true') return;

    slider.dataset.lucienReviewsReady = 'true';

    let isPointerDown = false;
    let isDragging = false;
    let startX = 0;
    let startScrollLeft = 0;

    const stopDragging = () => {
      if (!isPointerDown) return;

      isPointerDown = false;
      slider.classList.remove('is-dragging');

      window.setTimeout(() => {
        isDragging = false;
      }, 0);
    };

    slider.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch' || event.button !== 0) return;

      isPointerDown = true;
      isDragging = false;
      startX = event.clientX;
      startScrollLeft = slider.scrollLeft;
      slider.setPointerCapture(event.pointerId);
    });

    slider.addEventListener('pointermove', (event) => {
      if (!isPointerDown) return;

      const deltaX = event.clientX - startX;
      if (Math.abs(deltaX) > DRAG_THRESHOLD) {
        isDragging = true;
        slider.classList.add('is-dragging');
      }

      if (isDragging) {
        event.preventDefault();
        slider.scrollLeft = startScrollLeft - deltaX;
      }
    });

    slider.addEventListener('pointerup', stopDragging);
    slider.addEventListener('pointercancel', stopDragging);
    slider.addEventListener('pointerleave', stopDragging);

    slider.addEventListener(
      'click',
      (event) => {
        if (!isDragging) return;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
  };

  const init = (container = document) => {
    container.querySelectorAll(SELECTOR).forEach(initSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
